module.exports = __webpack_public_path__ + "img/flag_95.699217d5.png";